import { CategoryEditModel } from './category-edit.model';
import { MyCampApp } from '../common/enumerations';
import { AppTeamUtil } from '../../core/app-team-util';
import CategoryItemType = MyCampApp.CategoryItemType;

export class CategoryItemGroup
{
    typeId!: CategoryItemType;
    typeName!: string;
    itemList!: string;

    constructor(typeId: CategoryItemType, typeName: string, itemList: string) {
        this.typeId = typeId;
        this.typeName = typeName;
        this.itemList = itemList;
    }
}

export class CategoryItem
{
    Id!: number;
    ParentId?: number;
    Name!: string;
    Description!: string;
    CategoryItemType!: MyCampApp.CategoryItemType;
    ShowInApp = true;
    MemberTypeIds: number[] = [];
	Year: number = 0;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

	get calculatedName(): string { return `[${this.Year}] ${this.Name}`; }

    updateFromModel(model: CategoryEditModel)
    {
        this.Name = model.Name;
        this.Description = model.Description;
        this.CategoryItemType = model.CategoryItemType;
        this.ShowInApp = model.ShowInApp;
        this.MemberTypeIds = model.MemberTypeIds;
    }

    static grouped(categoryItems: CategoryItem[], useCalculatedName: boolean = false): CategoryItemGroup[]
    {
        const groups = AppTeamUtil.groupBy(categoryItems, (ci: CategoryItem) => ci.CategoryItemType)
	    return Array.from(groups.entries()).map(group =>
        {
	        const typeId = group[0];
	        const list = group[1].sort((cat1: CategoryItem, cat2: CategoryItem) => cat1.calculatedName.localeCompare(cat2.calculatedName));
	        return new CategoryItemGroup(typeId, MyCampApp.getCategoryItemTypeString(typeId), list.map((ci: CategoryItem) => useCalculatedName ? ci.calculatedName : ci.Name).join(', '));
        }).sort((g1, g2) => MyCampApp.isCategoryItemTypeSortedBefore(g1.typeId, g2.typeId));
    }
}
